var module =  angular.module("app.directives");

module.directive('currencyInput', function(){
  return {
    restrict: 'E',
    scope: {},
    replace:true,
    template: '<input type="text" class="form-control currency-control" ng-currency currency-symbol="£" />',
    link: function(scope, element, attrs){

    }
  }
})
